module.exports = __webpack_public_path__ + "static/media/设备完好率.5f19ae40.png";


//////////////////
// WEBPACK FOOTER
// ./src/AntD/assets/img/diagnostic/设备完好率.png
// module id = 4711
// module chunks = 0